/**
* Testimonials JS
* -----------------------------------------------------------------------------
*
* All the JS for the Testimonials component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'testimonials',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.testimonials__slick' ).slick( {
        infinite: true,
        dots: false,
        autoplay: false,
        fade: true,
        speed: 800,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '.testimonial-slider__prev',
        nextArrow: '.testimonial-slider__next',
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'testimonials', COMPONENT );
} )( app );
